module.exports = __webpack_public_path__ + "static/img/8.41f02336.png";